import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchClients } from "../../store/slices/clientsSlice";
import { MagnifyingGlassIcon, UsersIcon } from "@heroicons/react/24/outline";

export default function Clients() {
  const dispatch = useDispatch();
  const { list, totalClients, status } = useSelector((state) => state.clients);
  const [search, setSearch] = useState("");

  useEffect(() => {
    dispatch(fetchClients({ search }));
  }, [dispatch, search]);

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Clients</h1>
          <p className="text-gray-500 text-sm mt-1">{totalClients} total clients</p>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
        <div className="p-4 border-b border-gray-200">
          <div className="relative max-w-md">
            <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search clients..."
              className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500"
            />
          </div>
        </div>

        {status === "loading" ? (
          <div className="p-8 text-center">
            <div className="animate-spin h-8 w-8 border-2 border-indigo-600 border-t-transparent rounded-full mx-auto" />
          </div>
        ) : list.length === 0 ? (
          <div className="p-12 text-center">
            <UsersIcon className="h-12 w-12 text-gray-300 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-1">No clients yet</h3>
            <p className="text-sm text-gray-500 mb-4">Clients are automatically created when you build quotes</p>
            <Link to="/quotes/new" className="text-sm text-indigo-600 font-medium hover:text-indigo-500">
              Create your first quote
            </Link>
          </div>
        ) : (
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Email</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Phone</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Quotes</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Accepted</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {list.map((client) => (
                <tr key={client._id} className="hover:bg-gray-50">
                  <td className="px-6 py-4">
                    <p className="text-sm font-medium text-gray-900">
                      {client.firstName} {client.lastName}
                    </p>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-500">{client.email}</td>
                  <td className="px-6 py-4 text-sm text-gray-500">{client.phone || "-"}</td>
                  <td className="px-6 py-4 text-sm text-gray-900 font-medium">{client.quoteCount}</td>
                  <td className="px-6 py-4">
                    <span className={`text-sm font-medium ${client.acceptedCount > 0 ? "text-green-600" : "text-gray-400"}`}>
                      {client.acceptedCount}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
